<template>
  <v-dialog v-model="dialog" max-width="480" persistent>
    <v-card style="border-radius: 12px; overflow: hidden;">

      <div class="dialog-header dialog-header--danger">
        <v-icon color="white" class="mr-2">mdi-book-remove-outline</v-icon>
        <div>
          <div class="dialog-header-title">Confirmar Remoção</div>
          <div class="dialog-header-subtitle">O e-book será removido do pedido</div>
        </div>
      </div>

      <v-card-text class="pt-5 pb-3">
        <v-alert
          type="warning" dense outlined
          class="mb-4"
          style="font-size: 13px; border-radius: 8px;"
        >
          Esta ação removerá o e-book do pedido e reverterá o rateio de desconto. Não poderá ser desfeita.
        </v-alert>

        <div v-if="item" class="info-grid mb-4">
          <div class="info-item">
            <span class="info-label">Nº Pedido</span>
            <span class="info-value info-value--pedido">#{{ item.idorcamento }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Filial</span>
            <span class="info-value">{{ item.empresa || item.idempresa }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Cliente</span>
            <span class="info-value">{{ item.nomecliente }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Vendedor</span>
            <span class="info-value">{{ item.nomevendedor }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Combo</span>
            <div>
              <v-chip x-small :color="corCombo(item.combo)" dark style="font-weight: 600;">
                {{ item.combo }}
              </v-chip>
            </div>
          </div>
          <div class="info-item">
            <span class="info-label">Valor E-book</span>
            <span class="info-value info-value--destaque">{{ item.valorebook | formataDinheiro }}</span>
          </div>
        </div>

        <v-textarea
          v-model="motivo"
          label="Motivo da remoção (opcional)"
          outlined dense rows="2"
          hide-details
          :disabled="salvando"
          counter="255"
          maxlength="255"
          style="border-radius: 8px;"
          placeholder="Descreva o motivo para remover o e-book..."
        />
      </v-card-text>

      <v-card-actions class="px-5 pb-4 dialog-actions">
        <v-btn text :disabled="salvando" @click="fechar">Cancelar</v-btn>
        <v-btn
          color="error" elevation="0"
          :loading="salvando"
          style="border-radius: 8px;"
          @click="confirmar"
        >
          <v-icon left small>mdi-book-remove</v-icon>
          Confirmar Remoção
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogConfirmaRemocao',
  props: {
    value:    { type: Boolean, default: false },
    item:     { type: Object,  default: null  },
    salvando: { type: Boolean, default: false },
  },
  data: () => ({
    motivo: '',
  }),
  computed: {
    dialog: {
      get() { return this.value },
      set(v) { this.$emit('input', v) },
    },
  },
  watch: {
    value(aberto) {
      if (!aberto) this.motivo = ''
    },
  },
  methods: {
    fechar() {
      this.$emit('input', false)
    },
    confirmar() {
      this.$emit('confirmar', this.motivo.trim() || null)
    },
    corCombo(combo) {
      const cores = {
        'VIP':      'blue darken-1',
        'BRONZE':   'brown',
        'PRATA':    'blue-grey',
        'OURO':     'amber darken-2',
        'DIAMANTE': 'cyan darken-2',
      }
      return cores[combo] || 'primary'
    },
  },
}
</script>

<style scoped>
.dialog-header {
  padding: 16px 20px;
  display: flex;
  align-items: center;
}
.dialog-header--danger {
  background: linear-gradient(135deg, #b71c1c 0%, #c62828 100%);
}
.dialog-header-title {
  color: white;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}
.dialog-header-subtitle {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  margin-top: 2px;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 20px;
}
.info-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.info-label {
  font-size: 10px;
  color: #8fa8bc;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.info-value {
  font-size: 13px;
  color: #3d5166;
  font-weight: 500;
}
.info-value--pedido {
  font-size: 15px;
  font-weight: 700;
  color: #023449;
}
.info-value--destaque {
  font-size: 15px;
  font-weight: 700;
  color: #023449;
}

.dialog-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}
</style>
